var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"searchExams__empty-cart"},[_c('div',{staticClass:"searchExams__empty-cart--icon"},[_c('CartSvg')],1),_c('p',{staticClass:"searchExams__empty-cart--title"},[_vm._v("Seu carrinho está vazio!")]),_c('p',{staticClass:"searchExams__empty-cart--subtitle"},[_vm._v(" Adicione pelo menos 1 exame para continuar com o Check-in. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }